export default __webpack_public_path__ + "static/media/icons8-visual-studio-code-2019.347071b2.png";